import { render } from "./AllocationAddenda.vue?vue&type=template&id=c74fcd9a&scoped=true"
import script from "./AllocationAddenda.vue?vue&type=script&lang=js"
export * from "./AllocationAddenda.vue?vue&type=script&lang=js"

import "./AllocationAddenda.vue?vue&type=style&index=0&id=c74fcd9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74fcd9a"]])

export default __exports__